import React from "react";
import { connect } from "react-redux";

import {
  doGetAllRoutePlans,
  doCreateRoutePlan,
  doUpdateRoutePlan,
  doDeleteRoutePlan,
  doDuplicateRoutePlan,
} from "../stores/thunk";
import { selectAllRoutePlans } from "../stores/slice";

export default Component => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      isFetching: state.routePlan.isFetching,
      metadata: state.routePlan.metadata,
      message: state.routePlan.message,
      routePlans: selectAllRoutePlans(state),
    };
  }

  return connect(mapStateToProps, {
    doGetAllRoutePlans,
    doCreateRoutePlan,
    doUpdateRoutePlan,
    doDeleteRoutePlan,
    doDuplicateRoutePlan,
  })(Container);
};
